<template>
  <div class="dashboard-area-container p-4">
    <div class="mb-3">
      <vs-button icon="arrow_back" size="small" type="border" @click="$router.push('/actividades-control')">Volver</vs-button>
    </div>
    <vx-card title="Dashboard de Área">
      <div class="flex flex-wrap items-center mb-6 gap-3">
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Departamento</label>
          <v-select
            v-model="tdpId"
            :options="departamentos"
            :reduce="d => d.tdp_id"
            label="tdp_nombre"
            placeholder="Seleccione un departamento"
            class="w-full"
            @input="cargarDashboard"
          />
        </div>
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Fecha Inicio</label>
          <flat-pickr
            v-model="filtros.fecha_inicio"
            :config="configdateTimePicker"
            placeholder="Fecha inicio"
            class="w-full"
            @on-change="cargarDashboard"
          />
        </div>
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Fecha Fin</label>
          <flat-pickr
            v-model="filtros.fecha_fin"
            :config="configdateTimePicker"
            placeholder="Fecha fin"
            class="w-full"
            @on-change="cargarDashboard"
          />
        </div>
      </div>

      <div v-if="departamentoInfo" class="mb-6 p-4 bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg">
        <h2 class="text-xl font-bold">{{ departamentoInfo.tdp_nombre }}</h2>
        <p class="text-sm opacity-80" v-if="departamentoInfo.responsable">
          Responsable: {{ departamentoInfo.responsable.nombres }} {{ departamentoInfo.responsable.apellidos }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div class="stat-card bg-gradient-to-r from-blue-500 to-blue-600 text-white p-6 rounded-lg shadow-lg">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm opacity-80">Total Tareas</p>
              <h3 class="text-3xl font-bold mt-1">{{ dashboardData.total_tareas || 0 }}</h3>
            </div>
            <vs-icon icon="assignment" size="large" class="opacity-50" />
          </div>
        </div>
        <div class="stat-card bg-gradient-to-r from-green-500 to-green-600 text-white p-6 rounded-lg shadow-lg">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm opacity-80">Total Actividades</p>
              <h3 class="text-3xl font-bold mt-1">{{ dashboardData.total_actividades || 0 }}</h3>
            </div>
            <vs-icon icon="check_circle" size="large" class="opacity-50" />
          </div>
        </div>
        <div class="stat-card bg-gradient-to-r from-yellow-500 to-yellow-600 text-white p-6 rounded-lg shadow-lg">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm opacity-80">Empleados</p>
              <h3 class="text-3xl font-bold mt-1">{{ Object.keys(dashboardData.resumen_empleados || {}).length }}</h3>
            </div>
            <vs-icon icon="people" size="large" class="opacity-50" />
          </div>
        </div>
        <div class="stat-card bg-gradient-to-r from-purple-500 to-purple-600 text-white p-6 rounded-lg shadow-lg">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm opacity-80">Categorías</p>
              <h3 class="text-3xl font-bold mt-1">{{ Object.keys(dashboardData.resumen_categorias || {}).length }}</h3>
            </div>
            <vs-icon icon="category" size="large" class="opacity-50" />
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <vx-card title="Resumen por Empleado" class="mb-4">
          <vs-table :data="empleadosData" stripe>
            <template slot="thead">
              <vs-th>Empleado</vs-th>
              <vs-th>Tareas</vs-th>
              <vs-th>Cantidad</vs-th>
              <vs-th>Validadas</vs-th>
              <vs-th>Pendientes</vs-th>
              <vs-th>Rechazadas</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(emp, index) in data" :key="index">
                <vs-td>{{ emp.empleado }}</vs-td>
                <vs-td>{{ emp.total_tareas }}</vs-td>
                <vs-td>{{ emp.total_cantidad }}</vs-td>
                <vs-td>
                  <vs-chip color="success" class="text-white">{{ emp.validadas }}</vs-chip>
                </vs-td>
                <vs-td>
                  <vs-chip color="warning" class="text-white">{{ emp.pendientes }}</vs-chip>
                </vs-td>
                <vs-td>
                  <vs-chip color="danger" class="text-white">{{ emp.rechazadas }}</vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>

        <vx-card title="Resumen por Categoría" class="mb-4">
          <vs-table :data="categoriasData" stripe>
            <template slot="thead">
              <vs-th>Categoría</vs-th>
              <vs-th>Tareas</vs-th>
              <vs-th>Cantidad</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(cat, index) in data" :key="index">
                <vs-td>{{ cat.categoria }}</vs-td>
                <vs-td>{{ cat.total_tareas }}</vs-td>
                <vs-td>{{ cat.total_cantidad }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </vx-card>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'DashboardArea',
  components: {
    flatPickr,
    vSelect,
  },
  data() {
    return {
      tdpId: null,
      departamentos: [],
      filtros: {
        fecha_inicio: null,
        fecha_fin: null,
      },
      dashboardData: {},
      configdateTimePicker: {
        locale: Spanish,
        dateFormat: "Y-m-d",
        altFormat: "d/m/Y",
        altInput: true,
      },
    }
  },
  computed: {
    ...mapState(['auth', 'userRoot', 'susuario']),
    departamentoInfo() {
      return this.dashboardData.departamento || null
    },
    empleadosData() {
      const data = this.dashboardData.resumen_empleados
      if (!data) return []
      return Object.values(data)
    },
    categoriasData() {
      const data = this.dashboardData.resumen_categorias
      if (!data) return []
      return Object.values(data)
    },
  },
  mounted() {
    this.cargarDepartamentos()
  },
  methods: {
    async cargarDepartamentos() {
      try {
        const response = await this.$http.get(this.$server_url + 'actividades-control/departamentos')
        this.departamentos = response.data || []
      } catch (error) {
        console.error('Error al cargar departamentos:', error)
      }
    },
    async cargarDashboard() {
      if (!this.tdpId) return
      this.$vs.loading()
      try {
        const params = {}
        if (this.filtros.fecha_inicio) params.fecha_inicio = this.filtros.fecha_inicio
        if (this.filtros.fecha_fin) params.fecha_fin = this.filtros.fecha_fin
        const response = await this.$http.get(this.$server_url + `actividades-control/dashboard/departamento/${this.tdpId}`, { params })
        this.dashboardData = response.data || {}
      } catch (error) {
        console.error('Error al cargar dashboard:', error)
      } finally {
        this.$vs.loading.close()
      }
    },
  },
}
</script>

<style scoped>
.dashboard-area-container {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
